import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

class ScrollytellingHearts {
    constructor() {
        this.container = document.querySelector('.js-scrollytelling-hearts');
    }

    init() {
        if (this.container) {
            this.run();
        }
    }

    run() {
        const sections = gsap.utils.toArray('.js-scrollytelling-hearts .section');
        gsap.registerPlugin(ScrollTrigger);

        const debug = false;


        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: this.container,
                start: 'top bottom',
                end: 'top top',
                scrub: true,
                markers: debug
            }
        });

        timeline
            .to(this.container.querySelector('.section-one .background-hearts'), {
                opacity: 1,
                duration: 0.5
            }, 0)
            .to(document.querySelector('.js-scrollytelling-horizontal'), {
                opacity: 0,
                duration: 0.5
            }, ">")
            .to(this.container.querySelector('.section-one .background-hearts'), {
                top: 0,
                height: '100vh',
                transform: 'none',
                duration: 2,
                ease: 'power1.inOut',
            }, 1)
            .to(this.container.querySelector('.section-one .heart'), {
                width: '250px',
                height: '250px',
                duration: 2,
                ease: 'power1.inOut',
            }, 1);

        sections.forEach((section, index) => {
            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: section,
                    pin: true,
                    pinSpacing: false,
                    start: 'top top',
                    end: 'bottom top',
                    scrub: true,
                    markers: debug,
                }
            });

            switch (index) {
                case 0:
                    timeline
                        .from(section.querySelector('.container'), {
                            opacity: 0,
                            translateY: '50%',
                            ease: 'power1.inOut'
                        }, 1)
                        .to(section.querySelector('.container'), {
                            opacity: 1,
                            duration: 3,
                            ease: 'power1.in'
                        }, 1)
                        .to({}, {
                            delay: 2
                        })
                        .to(section, {
                            opacity: 0,
                            duration: 2,
                        }, '>');
                    break;

                case 1:
                    timeline
                        .from(section.querySelector('.container'), {
                            opacity: 0,
                            translateY: '50%',
                            duration: 1,
                            ease: 'power1.inOut'
                        })
                        .to(section.querySelectorAll('.background-hearts .heart'), {
                            scale: 3,
                            transformOrigin: 'center center',
                            duration: 5,
                            ease: 'power1.inOut'
                        }, '<')
                        .to(this.container, {
                            duration: 0,
                            backgroundColor: '#ffeb00',
                        }, '>')
                        .to(section.querySelectorAll('.background-hearts'), {
                            duration: 0,
                            opacity: 0
                        }, '<')
                        .to({}, {
                            delay: 2
                        })
                        .to(section.querySelector('.container'), {
                            opacity: 0,
                            delay: 1,
                            ease: 'power1.inOut'
                        }, 3);
                    break;

                default:
                    timeline
                        .from(section.querySelector('.container'), {
                            opacity: 0,
                            translateY: '50%',
                            duration: 1,
                            ease: 'power1.inOut'
                        })
                        .from(section.querySelector('.clipped-image'), {
                            transform: 'scale(0)',
                            transformOrigin: 'center center',
                            ease: 'power1.inOut'
                        });

                    if (index === sections.length - 1) {
                        let range = 1.25 / 250;
                        let vw = range * Math.min(window.innerWidth, window.innerHeight);

                        timeline
                            .to(section, {
                                overflow: 'hidden'
                            })
                            .to({}, {
                                delay: 2
                            })
                            .to(section.querySelector('.section-content .text-flow'), {
                                opacity: 0,
                                duration: 2,
                                ease: 'power2.inOut'
                            }, "<")
                            .to(section.querySelector('.clipped-image'), {
                                scale: vw,
                                transformOrigin: 'center center',
                                translateY: '10vh',
                                duration: 5,
                                ease: 'power2.inOut'
                            });
                    } else {
                        timeline
                            .to(section.querySelector('.container'), {
                                opacity: 0,
                                delay: 1,
                                ease: 'power1.inOut'
                            }, ">");
                    }

                    break;
            }
        });
    }
}

export default new ScrollytellingHearts();
